<span [ngSwitch]="status">
  <span class="badge bg-light text-dark" *ngSwitchCase="'DRAFT'">Ouvert</span>
  <span class="badge bg-success text-light" *ngSwitchCase="'COMPLETED'">Complété</span>
</span>